if (!customElements.get('stadiart-announcement')) {
  customElements.define('stadiart-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.viewport = this.querySelector('.sa-announcement__slides');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.hovered = false;
      this.focused = this.contains(document.activeElement);

      this.querySelectorAll('[data-previous], [data-next]').forEach((button) => {
        button.hidden = false;
      });
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1, true);
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.schedule();
      }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.schedule();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
    }

    move(direction, manual = false) {
      this.viewport.setAttribute('aria-live', manual ? 'polite' : 'off');
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      const active = this.slides[this.index];
      active.classList.add('is-active');
      active.setAttribute('aria-hidden', 'false');
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (!this.isConnected || this.hovered || this.focused || document.hidden || this.motion.matches) return;
      this.timer = window.setTimeout(() => this.move(1), 5000);
    }
  });
}
